module.exports = __webpack_public_path__ + "static/media/step2img11.aafa3e8c.JPG";